<template>
    <div class="layout-content">

        <div class="course-mid">
            <el-tabs v-model="isActive" type="card">
                <el-tab-pane label="Week" name="week">
                    
                    
                <div class="mid-top">

                    <div class="time-operate">
                        <i class="el-icon-back" style="margin-right:9px;" @click="leftClick"></i>
                        <i class="el-icon-right" @click="rightClick"></i>
                        <span class="date">{{monthEnglish[nowMonth-1]+ '  '+ nowYear}}</span>
                    </div>
                    <div class="top-mid-title">
                        <div style="text-align: center">{{ startTime }}-{{ endTime }}</div>
                    </div>
                </div>
    
                    <el-table ref="headerTable" :data="dateweek" border style="width: 100%; overflow: hidden;">
                        <el-table-column class-name="hour-time" label="T" width="38"> </el-table-column>
                        <el-table-column prop="sun" label="Sun"> </el-table-column>
                        <el-table-column prop="mon" label="Mon"> </el-table-column>
                        <el-table-column prop="tues" label="Tues"> </el-table-column>
                        <el-table-column prop="wed" label="Wed"> </el-table-column>
                        <el-table-column prop="thur" label="Thur"> </el-table-column>
                        <el-table-column prop="fri" label="Fri"> </el-table-column>
                        <el-table-column prop="sat" label="Sat"> </el-table-column>
                    </el-table>

                    <el-scrollbar style="height: 80vh;margin-bottom:8px;">
                        <el-table ref="bodyTable" class="table-body" :data="scheduleData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 0px" :show-header="false" @cell-click="clickSchedule" :cell-style="setCellStyle">
                            <el-table-column class-name="hour-time" prop="hour" label="Time" width="38"> </el-table-column>

                            <el-table-column prop="sun" label="Sunday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.sun['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.sun['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.sun.apdate+'  '+scope.row.sun.starttime + '-'+scope.row.sun.endtime }}</div>

                                            <div v-if="scope.row.sun&&scope.row.sun['covey_user.realname']" class="schedule-popover-item">{{scope.row.sun.caltype===0 ?'Tutor: ':'Student: '+scope.row.sun['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.sun.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.sun)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.sun.bookuserId===null?'(Empty)':(scope.row.sun.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.sun['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else></div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="mon" label="Monday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.mon['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.mon['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.mon.apdate+'  '+scope.row.mon.starttime + '-'+scope.row.mon.endtime }}</div>

                                            <div v-if="scope.row.mon&&scope.row.mon['covey_user.realname']" class="schedule-popover-item">{{scope.row.mon.caltype===0 ?'Tutor: ':'Student: '+scope.row.mon['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.mon.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.mon)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.mon.bookuserId===null?'(Empty)':(scope.row.mon.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.mon['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.mon['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tues" label="Tuesday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.tues['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.tues['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.tues.apdate+'  '+scope.row.tues.starttime + '-'+scope.row.tues.endtime }}</div>

                                            <div v-if="scope.row.tues&&scope.row.tues['covey_user.realname']" class="schedule-popover-item">{{scope.row.tues.caltype===0 ?'Tutor: ':'Student: '+scope.row.tues['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.tues.roomsite">
                                                <el-button @click="openCourseAdressDialog">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.tues.bookuserId===null?'(Empty)':(scope.row.tues.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.tues['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.tues['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="wed" label="Wednesday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.wed['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.wed['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.wed.apdate+'  '+scope.row.wed.starttime + '-'+scope.row.wed.endtime }}</div>

                                            <div v-if="scope.row.wed&&scope.row.wed['covey_user.realname']" class="schedule-popover-item">{{scope.row.wed.caltype===0 ?'Tutor: ':'Student: '+scope.row.wed['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.wed.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.wed)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.wed.bookuserId===null?'(Empty)':(scope.row.wed.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.wed['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.wed['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="thur" label="Thursday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.thur['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.thur['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.thur.apdate+'  '+scope.row.thur.starttime + '-'+scope.row.thur.endtime }}</div>

                                            <div v-if="scope.row.thur&&scope.row.thur['covey_user.realname']" class="schedule-popover-item">{{scope.row.thur.caltype===0 ?'Tutor: ':'Student: '+scope.row.thur['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.thur.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.thur)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.thur.bookuserId===null?'(Empty)':(scope.row.thur.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.thur['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.thur['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fri" label="Friday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.fri['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.fri['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.fri.apdate+'  '+scope.row.fri.starttime + '-'+scope.row.fri.endtime }}</div>

                                            <div v-if="scope.row.fri&&scope.row.fri['covey_user.realname']" class="schedule-popover-item">{{scope.row.fri.caltype===0 ?'Tutor: ':'Student: '+scope.row.fri['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.fri.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.fri)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.fri.bookuserId===null?'(Empty)':(scope.row.fri.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.fri['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.fri['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sat" label="Saturday">
                                <template slot-scope="scope">
                                    <el-popover v-if="scope.row.sat['covey_course.courseName']" popper-class="schedule-popover" trigger="click" placement="right">
                                        <div>
                                            <div class="schedule-popover-title">{{ scope.row.sat['covey_course.courseName'] }}</div>
                                            <div class="schedule-popover-item">{{ scope.row.sat.apdate+'  '+scope.row.sat.starttime + '-'+scope.row.sat.endtime }}</div>

                                            <div v-if="scope.row.sat&&scope.row.sat['covey_user.realname']" class="schedule-popover-item">{{scope.row.sat.caltype===0 ?'Tutor: ':'Student: '+scope.row.sat['covey_user.realname']}}</div>
                                            <div class="schedule-popover-item" style="float: right;" v-if="scope.row.sat.roomsite">
                                                <el-button @click="openCourseAdressDialog(scope.row.sat)">Go to class</el-button>
                                            </div>
                                        </div>
                                        <div slot="reference">
                                            {{scope.row.sat.bookuserId===null?'(Empty)':(scope.row.sat.bookuserId===userInfo.id?'(T)':'(S)')}}{{scope.row.sat['covey_course.courseName'].substring(0,10)+'...'}}
                                        </div>
                                    </el-popover>
                                    <div v-else>{{scope.row.sat['covey_course.courseName']}}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>

                </el-tab-pane>

                <el-tab-pane label="Month" name="month">
                    <div class="mid-top">
                        <div>
                            <i class="el-icon-back" style="margin-right:9px;" @click="leftClickMonth"></i>
                            <i class="el-icon-right" @click="rightClickMonth"></i>
                        </div>
                        <div class="time-operate">
                            <span class="date">{{monthEnglish[nowMonth-1]+ '  '+ nowYear}}</span>
                        </div>
                    </div>
                    <el-calendar ref="class-schedule-calendar" :first-day-of-week="7">
                        <template slot="dateCell" slot-scope="{ data }" class="calItem">
                            
                            <div class="el-calendar-day_container" @click="calClick(data)">

                                    <el-popover v-if="calendarData.some(item=>{return item.apdate===data.day})" trigger="click" placement="right">

                                        <div v-for="(item, index) in calendarData" :key="index">
                                            <div v-if="item.apdate===data.day" class="popover-list-item">
                                                {{ item.starttime+' : '+item['covey_course.courseName'] }}
                                            </div>
                                        </div>
                                        <div slot="reference" style="height:100%;">
                                            <div :class="data.isSelected ? 'is-selected' : ''" class="calendar-day">
                                                <span class="dayItem" v-if="data.day.substr(-2) < 10">
                                                    {{ data.day.substr(-1) }}
                                                </span>
                                                <span class="dayItem" v-else>{{ data.day.substr(-2) }}</span>

                                                <div class="course-line">more</div>

                                                <!-- <div v-for="(item, index) in calendarData" :key="index">
                                                    <div class="course-line" v-if="item.apdate===data.day">
                                                        more
                                                    </div>
                                                </div> -->
                                                
                                            </div>
                                        </div>
                                    </el-popover>
                                    <div v-else>
                                        <div :class="data.isSelected ? 'is-selected' : ''">
                                            <p class="dayItem" v-if="data.day.substr(-2) < 10">
                                                {{ data.day.substr(-1) }}
                                            </p>
                                            <p class="dayItem" v-else>{{ data.day.substr(-2) }}</p>
                                        </div>
                                    </div>
                            </div>
                        </template>
                        
                    </el-calendar>
                </el-tab-pane>
            </el-tabs>

        </div>

        <el-dialog custom-class="classschedule-courses-address-dialog" title="Course address" :visible.sync="courseAdressDialog" label-width="160px">
            <div class="form-item">
                <label class="form-title">Course Title:</label>
                <div class="form-content">{{courseRoomInfo['covey_course.courseName']}}</div>
            </div>
            <div class="form-item">
                <label class="form-title">Copy course link:</label>
                <div class="form-content">
                    <a :href="courseRoomInfo.roomsite" target="_blank">{{courseRoomInfo.roomsite}}</a>
                </div>
            </div>

            <div class="form-item">
                <label class="form-title">Course code:</label>
                <div class="form-content">{{courseRoomInfo.roomcode}}</div>
            </div>

            <div class="box-foot">
                <div class="my-button cancel" @click="courseAdressDialog = false">CANCEL</div>
                <div class="my-button">COPY</div>
            </div>
        </el-dialog>
    </div>
</template>
<script src="././utils/date.js"></script>
<script>
var WEEKMAP = {
    'Sunday': 'sun',
    'Monday': 'mon',
    'Tuesday': 'tues',
    'Wednesday': 'wed',
    'Thursday': 'thur',
    'Friday': 'fri',
    'Saturday': 'sat',
}
import { mapState } from "vuex";
import { format } from "@/utils/comm";
import { getDateInfo } from "@/utils/date";
export default {
    data() {
        return {
            monthEnglish: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

            formData: {
                data: "",
                content: "",
            },
            calendarData: [],
            value: new Date(),
            form: { timeArr: [], type: 1 },

            isActive: 'week',

            lastDay: "",
            nextDay: "",
            startTime: "",
            nowYear: "",
            nowMonth: "",
            endTime: "",
            arr: [],
            re_data: [],
            weekListe: [
                {
                    hour: 8,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 8,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 9,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 9,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 10,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 10,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 11,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 11,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 12,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 12,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 13,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 13,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 14,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 14,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 15,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 15,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 16,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 16,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 17,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 17,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 18,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 18,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 19,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 19,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 20,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 20,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 21,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 21,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 22,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
                {
                    hour: 22,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                },
            ],
            week_res: [[2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0,]],
            weekArr: ["sun", "mon", "tues", "wed", "thur", "fri", "sat",],
            courseAdressDialog: false,
            scheduleData: [],
            courseRoomInfo: {},//go to class 时暂存数据

            colorList: [
                '#fcc081',
                '#d3aef4',
                '#f9aecd',
                '#fe9f9d',
                '#fec461',
                '#80cff8',
                '#acbefe',
            ],
            classColorMap: {

            }
        };
    },
    computed: {
        ...mapState({
            shopCont: (state) => state.app.shopCont,
            navTree: (state) => state.menu.navTree,
            userInfo: (state) => state.app.userInfo,
        }),
        cupnowDateList() {
            let array = [];
            this.arr.forEach((item, i) => {
                let ary = item.split("-");

                array.push(ary[1] + "/" + ary[2]);
            });
            return array;
        },
        dateweek() {
            let array = [];
            let obj = {};
            this.arr.forEach((item, i) => {
                let ary = item.split("-");
                
                let tem = 'th'
                if ((ary[2] + '') === '1') tem = 'st';
                if ((ary[2] + '') === '2') tem = 'nd';
                if ((ary[2] + '') === '3') tem = 'rd';

                // array.push(ary[1] + "/" + ary[2])
                if (i == 0) {
                    obj["sun"] = ary[2] + tem;
                }
                if (i == 1) {
                    obj["mon"] = ary[2] + tem;
                }
                if (i == 2) {
                    obj["tues"] = ary[2] + tem;
                }
                if (i == 3) {
                    obj["wed"] = ary[2] + tem;
                }
                if (i == 4) {
                    obj["thur"] = ary[2] + tem;
                }
                if (i == 5) {
                    obj["fri"] = ary[2] + tem;
                }
                if (i == 6) {
                    obj["sat"] = ary[2] + tem;
                }
            });
            array.push(obj);

            return array;
        },
    },
    created: function () {

    },
    mounted() {

        this.getWeeks();
        this.initTableData();

        this.changeTime();
        let date = new Date();
        this.nowYear = date.getFullYear();
        this.nowMonth = date.getMonth() + 1;


        let t = new Date()
        let startdate = format(new Date(t.getFullYear(), t.getMonth(), 1), 'YYYY-MM-DD');
        let enddate = format(new Date(t.getFullYear(), t.getMonth() + 1, 0), 'YYYY-MM-DD');
        this.getMonthDateSchedule(startdate, enddate);


        this.syncScroll()

    },
    filters: {
        // numPartition(num) {
        //     if (!num) {
        //         return 0;
        //     }
        //     let numBefore = num.toString().split(".")[0];
        //     let numQueen = num.toString().split(".")[1];
        //     let decimals = parseInt(numQueen) > 0 ? true : false;
        //     return (
        //         (numBefore || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
        //         (decimals ? "." + numQueen : "")
        //     );
        // },
    },
    methods: {
        async getScheduleList() {
            let startdate = this.arr[0];
            let enddate = this.arr[6];
            await this.$api.courseApi.getCalendar({ startdate, enddate }).then(res => {
                if (res.status === '0') {
                    this.re_data = res.data;
                }
            })
        },
        //获取 月日历
        getMonthDateSchedule(startdate, enddate) {
            this.$api.courseApi.getMonthCalendar({ startdate, enddate }).then(res => {
                if (res.status === '0') {
                    this.calendarData = res.data;
                }
            })
        },
        //更新表格数据
        initTableData() {
            this.getScheduleList().then(() => {

                for (let item of this.weekListe) {
                    item.mon = {};
                    item.tues = {};
                    item.wed = {};
                    item.thur = {};
                    item.fri = {};
                    item.sat = {};
                    item.sun = {};
                }
                this.week_res = [[2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0,]];
                //日历对象转化 异步问题
                for (let item of this.re_data) {
                    this.classColorMap[item.cId] = 0;//颜色
                    this.weekListe[item.hour * 2 + item.period - 17][item.week] = item;
                    for (let i = 1; i < item.slot; i++) {
                        this.weekListe[item.hour * 2 + item.period - 17 + i][item.week] = item;
                    }
                }

                let tempIndex = 0;
                for (let key in this.classColorMap) {
                    this.classColorMap[key] = this.colorList[tempIndex];
                    tempIndex++
                    if (tempIndex >= this.colorList.length) {
                        tempIndex = 0;
                    }
                }
                for (let key of this.weekArr) {
                    let t_arr = []
                    for (let i = 0; i < this.weekListe.length; i++) {
                        let j = 1;
                        if (this.weekListe[i][key].id) {//如果有课程值
                            while (this.weekListe[i + 1][key] &&
                                this.weekListe[++i][key].id &&
                                this.weekListe[i][key].id === this.weekListe[i - 1][key].id) {
                                j++
                            }
                            t_arr.push(j);
                            if (j > 1) {
                                i--;
                            }
                            for (let num = 0; num < j - 1; num++) {
                                t_arr.push(0);
                            }
                        } else {
                            t_arr.push(1);
                        }
                    }
                    this.week_res.push(t_arr);
                }
                this.scheduleData = this.weekListe;
            });
        },
        clickSchedule(row, column, cell, event) {
            // console.log(row,column);
        },
        //设置课表颜色
        setCellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label !== 'Time') {
                if (row[WEEKMAP[column.label]].id) {
                    return {
                        background: this.classColorMap[row[WEEKMAP[column.label]].cId],
                        // background: '#F48C06',
                        color: '#fff'
                    }
                }
            }
            return {}
        },
        openCourseAdressDialog(item) {
            this.courseRoomInfo = item;
            this.courseAdressDialog = true;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {

            // 得到行合并的数据

            const rowNum = this.week_res[columnIndex][rowIndex];
            // 列合并
            const colNum = rowNum > 0 ? 1 : 0;
            // 当前位置的行合并和列合并数据
            return {
                rowspan: rowNum,
                colspan: colNum,
            };
        },
        leftClickMonth() {
            this.nowMonth = this.nowMonth - 1;
            if (this.nowMonth < 1) {
                this.nowMonth = 12;
                this.nowYear = parseInt(this.nowYear) - 1;
            }

            this.$refs['class-schedule-calendar'].selectDate('prev-month');
            let startdate = format(new Date(this.nowYear, this.nowMonth - 1, 1), 'YYYY-MM-DD');
            let enddate = format(new Date(this.nowYear, this.nowMonth, 0), 'YYYY-MM-DD');

            this.$nextTick(() => {
                this.getMonthDateSchedule(startdate, enddate);
            })

        },
        rightClickMonth() {
            this.nowMonth = this.nowMonth + 1;
            if (this.nowMonth > 12) {
                this.nowMonth = 1;
                this.nowYear = parseInt(this.nowYear) + 1;
            }
            this.$refs['class-schedule-calendar'].selectDate('next-month');
            let startdate = format(new Date(this.nowYear, this.nowMonth - 1, 1), 'YYYY-MM-DD');
            let enddate = format(new Date(this.nowYear, this.nowMonth, 0), 'YYYY-MM-DD');
            this.$nextTick(() => {
                this.getMonthDateSchedule(startdate, enddate);
            })

        },
        
        calClick(item) {
            if(item&&item.type==='next-month'){//下个月
                this.nowMonth = this.nowMonth + 1;
                if (this.nowMonth > 12) {
                    this.nowMonth = 1;
                    this.nowYear = this.nowYear + 1;
                }
            }else if(item&&item.type==='prev-month'){//上个月
                this.nowMonth = this.nowMonth - 1;
                if (this.nowMonth < 1) {
                    this.nowMonth = 12;
                    this.nowYear = this.nowYear - 1;
                }

            }else{
                return;
            }
            let startdate = format(new Date(this.nowYear, this.nowMonth-1 ,1),'YYYY-MM-DD');
            let enddate = format(new Date(this.nowYear, this.nowMonth, 0),'YYYY-MM-DD');
            this.$nextTick(() => {
                this.calendarData= []
                this.getMonthDateSchedule(startdate,enddate);
            })
        },

        nowDate(type, dates, date) {
            var now = "";
            if (date) {
                now = new Date(date);
            } else {
                now = new Date();
            }

            var nowTime = now.getTime();
            var day = now.getDay();
            var longTime = 24 * 60 * 60 * 1000;
            var n = longTime * 7 * (dates || 0);
            if (type == "s") {
                var dd = nowTime - (day - 0) * longTime + n;
            }
            if (type == "e") {
                var dd = nowTime + (6 - day) * longTime + n;
            }
            dd = new Date(dd);
            var y = dd.getFullYear();
            var m = dd.getMonth() + 1;
            var d = dd.getDate();
            m = m < 10 ? "0" + m : m;
            d = d < 10 ? "0" + d : d;
            var day = y + "-" + m + "-" + d;
            return day;
        },
        //上一周
        leftClick() {
            var d = this.getMonDate(this.nowDate("s", -1, this.arr[0]));
            var arr = [];
            for (var i = 0; i < 7; i++) {
                arr.push(d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate());
                d.setDate(d.getDate() + 1);
            }
            this.arr = arr;
            this.changeTime();
            this.initTableData();
        },
        //下一周
        rightClick() {
            var d = this.getMonDate(this.nowDate("s", 1, this.arr[6]));
            var arr = [];
            for (var i = 0; i < 7; i++) {
                arr.push(
                    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
                );
                d.setDate(d.getDate() + 1);
            }
            this.arr = arr;
            this.changeTime();
            this.initTableData();
        },
        getWeeks() {
            var d = this.getMonDate(this.nowDate("s"));
            var arr = [];
            for (var i = 0; i < 7; i++) {
                arr.push(
                    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
                );
                d.setDate(d.getDate() + 1);
            }
            this.arr = arr;
        },
        getMonDate(data) {
            var d = new Date(data);
            var day = d.getDay();
            var date = d.getDate();
            if (day == 0) return d;
            if (day == 6) d.setDate(date + 6);
            else d.setDate(date - day + 1);
            return d;
        },
        changeTime() {
            let start = this.arr[0];
            let timelist = start.split("-");
            this.startTime = timelist[1] + "/" + timelist[2] + "";

            let start2 = this.arr[6];
            let timelist1 = start2.split("-");
            this.endTime = timelist1[1] + "/" + timelist1[2] + "";


            this.nowMonth = timelist[1];
            this.nowYear = timelist[0];
        },
        syncScroll() {
            let firstTable = this.$refs.headerTable.bodyWrapper
            let secondTable = this.$refs.bodyTable.bodyWrapper
            firstTable.addEventListener("scroll", () => {
                secondTable.scrollLeft = firstTable.scrollLeft
            })
            secondTable.addEventListener("scroll", () => {
                firstTable.scrollLeft = secondTable.scrollLeft
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.popover-list-item {
    background: #f79d3e;
    padding: 5px 6px;
    margin: 4px 0;
    color: #fff;
    border-radius: 4px;
    &:hover {
        background: #f6ab5b;
    }
}
.layout-content {
    width: 100%;
    // padding: vw(48) vw(198);
    box-sizing: border-box;
    .calendar-day {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
    }
    .table-body {
        padding-bottom: 2px;
        
        
    }
    /deep/.hour-time {
        width: 16px;
    }
    
        /deep/.el-calendar-day{
            padding: 0;
            
            .el-calendar-day_container{
                padding: 8px;
                height: 100%;
                box-sizing: border-box;
            }
        }

    .course-mid {
        box-sizing: border-box;
        padding: 12px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        .el-calendar{
            /deep/.el-calendar__body{
                padding: 0;
            }
        }
        /deep/.el-tabs__header{
            margin: 0;
        }
        .mid-top {
            
            box-sizing: border-box;
            // padding-left: vw(56);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 6px;
            border-left: 1px solid #E4E7ED;
            border-right: 1px solid #E4E7ED;
            
            .time-operate {
                font-size: 18px;
                i {
                    cursor: pointer;
                }
                .date {
                    margin-left: 16px;
                    font-weight: 600;
                    color: #f48c06;
                    line-height: 25px;
                }
            }
            .time-classify {
                font-size: 14px;
                font-weight: 600;
                color: #201002;
                line-height: 20px;
                display: flex;
                .word-week {
                    cursor: pointer;
                }
                .color-word-ban {
                    color: #f48c06;
                }
            }
        }
    }

    /deep/.el-calendar table{
        border-collapse: collapse;
    }
    /deep/thead{
        
        border-top: 1px solid #E4E7ED;
        border-left: 1px solid #E4E7ED;
        border-right: 1px solid #E4E7ED;
    }
    /deep/.el-table__body tr,
    .el-table__body td {
        padding: 0;
        width: 20px;
        height: 60px;
    }
    /deep/.el-table::before {
        height: 0px;
    }
    /deep/.el-calendar__header {
        display: none;
    }
    .statisticsIntro {
        position: relative;
        display: flex;
        margin: 0 0 30px;
        padding: 35px 0px 5px;
        text-align: center;
        font-family: "Hiragino Sans GB";
        justify-content: space-around;
        box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.2);
    }
    .titleSub {
        position: absolute;
        top: 2px;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 700;
        font-size: 16px;
        padding: 0;
    }
    .statisticsIntro > .part {
        width: 1px;
        height: 58px;
        margin: 0 8px;
        background: #ccc;
    }
    .statisticsIntro > .subfield {
        flex: 1;
    }
    .statisticsIntro > .subfield > p {
        margin: 3px 0 10px;
    }
    .statisticsIntro > .subfield > span {
        color: #a6e22e;
    }

    .course-line {
        font-size: 12px;
        color: #f48c06;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 1;
        // -webkit-box-orient: vertical;
    }
}
.schedule-popover {
    padding: vw(24) vw(32);
    box-sizing: border-box;
    width: 340px;
    .schedule-popover-title {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #201002;
        line-height: 33px;
        margin-bottom: 16px;
    }
    .schedule-popover-item {
        margin-top: 4px;
        font-weight: 600;
        font-size: 14px;
        color: #201002;
        .el-button {
            border: none;
            color: #ffffff;
            background: #f48c06;
            margin-top: 20px;
            border-radius: 8px;
            height: 32px;
            display: flex;
            align-items: center;
        }
    }
}
.classschedule-courses-address-dialog {
    
    /deep/.el-dialog__body{
        padding: 16px;
    }
    .form-item {
        margin-bottom: 16px;
    }
    .form-title {
        font-size: 18px;
        font-weight: 500;
        color: #201002;
        line-height: 20px;
        text-align: left;
        vertical-align: middle;
        line-height: 20px;
    }
    .form-content {
        line-height: 20px;
        color: #201002;
    }

    .box-foot {
        margin-top: 46px;
        display: flex;
        justify-content: center;
        font-size: 14px;
    }
    .my-button {
        cursor: pointer;
        width: 120px;
        height: 48px;
        background: #f48c06;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        span {
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
        }
    }
    .cancel {
        margin-right: 24px;
        background: #f2f2f2;
        color: #201002;
    }
}
</style>
